import React from "react";

/**
 * Minimal SVG sparkline.
 * Props:
 *  - data: number[]
 *  - width, height
 *  - color: stroke color (default cobalt)
 *  - showLastDot: highlight last point
 */
export default function Sparkline({ data = [], width = 160, height = 36, color = "#0033A0", showLastDot = true }) {
    if (!data || data.length < 2) {
        return (
            <svg width={width} height={height} className="block">
                <line x1={0} y1={height - 1} x2={width} y2={height - 1} stroke="#E5E7EB" strokeWidth={1} />
            </svg>
        );
    }
    const min = Math.min(...data, 0);
    const max = Math.max(...data, 1);
    const range = max - min || 1;
    const step = data.length > 1 ? width / (data.length - 1) : width;
    const yFor = (v) => height - 2 - ((v - min) / range) * (height - 4);

    const points = data.map((v, i) => `${i * step},${yFor(v)}`).join(" ");
    const lastX = (data.length - 1) * step;
    const lastY = yFor(data[data.length - 1]);

    // Build area path
    const areaPath = `M0,${height} L${data.map((v, i) => `${i * step},${yFor(v)}`).join(" L")} L${lastX},${height} Z`;

    return (
        <svg width={width} height={height} className="block" data-testid="sparkline">
            <path d={areaPath} fill={color} fillOpacity={0.08} />
            <polyline points={points} fill="none" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
            {showLastDot && (
                <circle cx={lastX} cy={lastY} r={2.5} fill={color} />
            )}
        </svg>
    );
}
